import React from 'react';
import { func, number } from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import { contextPropTypes } from '../../../../../proptypes/shared';
import TrailPropType from '../../../../../proptypes/TrailPropType';
import styles from './styles/styles.module.scss';
import TrailResultCard from '../../../../../components/cards/TrailResultCard';
import useReduxListItems from '../../../hooks/useReduxListItems';

const CommunityTrailCard = ({ trail, context, handleCardClick, idx }) => {
  const { listItems } = useSelector(state => state.lists, shallowEqual);
  const { isFavorite, isVerified, isCompleted, handleFavoriteClick } = useReduxListItems(trail, listItems);

  return (
    <TrailResultCard
      className={styles.trailResultCard}
      imageCarouselClassName={styles.imageCarousel}
      allowItemMoving={false}
      context={context}
      displayRank={null}
      forceCityLink={false}
      handleCardClick={handleCardClick}
      handleFavoriteClick={handleFavoriteClick}
      handleLocationClick={() => {}}
      idx={idx}
      isCompleted={isCompleted}
      isFavorite={isFavorite}
      isMobileWidth={false}
      isVerified={isVerified}
      key={`trail-${trail.ID}`}
      showFavoriteHeart
      tabletBrowser={context.tabletBrowser}
      trail={trail}
    />
  );
};

CommunityTrailCard.propTypes = {
  trail: TrailPropType.isRequired,
  context: contextPropTypes.isRequired,
  handleCardClick: func,
  idx: number
};

CommunityTrailCard.defaultProps = {
  handleCardClick: () => {},
  idx: 0
};

export default CommunityTrailCard;
